import React, {
    Component
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { Table, Tag, Space } from 'antd';
import { DatePicker, TimePicker } from 'antd'
import { useNavigate } from 'react-router-dom';
const { Option } = Select;
const { RangePicker } = DatePicker;

// class PMPScheduleCancel extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             title: "Preventive Maintenance Planner ",
//             TableColumns: [
//                 {
//                     title: "Main Category",
//                     dataIndex: "MainCategory",
//                     key: "MainCategory"
//                 },
//                 {
//                     title: "Sub Category",
//                     dataIndex: "SubCategory",
//                     key: "SubCategory"
//                 },
//                 {
//                     title: "Vendor Name",
//                     dataIndex: "VendorName",
//                     key: "VendorName"
//                 },
//                 {
//                     title: "PM Start Date",
//                     dataIndex: "PMStartDate",
//                     key: "PMStartDate"
//                 },
//                 {
//                     title: "PM End Date",
//                     dataIndex: "PMEndDate",
//                     key: "PMEndDate"
//                 },
//                 {
//                     title: 'Action',
//                     dataIndex: 'action',
//                     key: 'action',
//                     render: (text, record) => (
//                         <Space size="middle">
//                             <div className="table-icons">
//                                 <span className="table-action cancel">Cancel</span>
//                             </div>
//                         </Space>
//                     ),
//                 }
//             ],
//             TableData: [
//                 {
//                     key: '1',
//                     MainCategory: "ELECTRICAL",
//                     SubCategory: "TRANSFORMER",
//                     VendorName: "Vendor 1",
//                     PMStartDate: "05-08-2021",
//                     PMEndDate: "05-12-2021"
//                 },
//                 {
//                     key: '2',
//                     MainCategory: "ELECTRICAL",
//                     SubCategory: "SWITCH BORAD",
//                     VendorName: "Vendor 2",
//                     PMStartDate: "05-08-2021",
//                     PMEndDate: "05-12-2021"
//                 },
//                 {
//                     key: '3',
//                     MainCategory: "ELECTRICAL",
//                     SubCategory: "Light System",
//                     VendorName: "Vendor 3",
//                     PMStartDate: "05-08-2021",
//                     PMEndDate: "05-12-2021"
//                 }

//             ],
//             StoresList: [
//                 {
//                     Label: "Connect Store - ITPB",
//                     Value: 1
//                 },
//                 {
//                     Label: "Connect Store- Indiranagar",
//                     Value: 2
//                 },
//                 {
//                     Label: "Sarjapur",
//                     Value: 3
//                 },
//                 {
//                     Label: "Anubhava (New Airport Road)",
//                     Value: 4
//                 },
//                 {
//                     Label: "EVA Mall - Brigade",
//                     Value: 5
//                 },
//                 {
//                     Label: "R-city(Mumbai)",
//                     Value: 6
//                 },
//                 {
//                     Label: "Amanora Mall",
//                     Value: 7
//                 },
//                 {
//                     Label: "OMR Padur(Chennai)",
//                     Value: 8
//                 },
//                 {
//                     Label: "Teynampet / Ramee Mall / Anna Salai",
//                     Value: 9
//                 },
//                 {
//                     Label: "Kukatpally (Manjeera Mall)",
//                     Value: 10
//                 },
//                 {
//                     Label: "Vishakapatnam (Murli Nagar)",
//                     Value: 11
//                 },
//             ],
//         }
//     }
//     _doNavToPMPList = () => {
//         this.props.navigate("/PMPList");
//     }
//     render() {
//         return (
//             <div className="wrapper">
//                 <Header title={this.state.title} />
//                 <Menu1 />
//                 <div className='content-wrapper'>
//                     <section className='content top-space'>
//                         <div className="m-panel">
//                             <div className="m-panel__body p10">
//                                 <div className="row">
//                                     <div className="col-md-3">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Store*</label>
//                                             <Select className="form-control"
//                                                 showSearch
//                                                 onChange={this._doSelectVender}
//                                                 placeholder="-- Please Select --"
//                                                 optionFilterProp="children"
//                                                 filterOption={(input, option) =>
//                                                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                 }
//                                             > {
//                                                     this.state.StoresList.map((item =>
//                                                         <Option value={item.Value}>{item.Label}</Option>
//                                                     ))
//                                                 }
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-3">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>PM start date</label>
//                                             <DatePicker className="form-control" />
//                                         </div>
//                                     </div>
//                                     <div className="col-md-3">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>PM end date</label>
//                                             <DatePicker className="form-control" />
//                                         </div>
//                                     </div>
//                                     <div className="col-md-3 btn-no-lbl">
//                                         <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'>
//                                             <i className="fa fa-search"></i>
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="m-panel">
//                             <div className="m-panel__body p10">

//                                 <div className="m-table__main">
//                                     <div className="m-table__responsive medium-width">
//                                         <Table columns={this.state.TableColumns} dataSource={this.state.TableData} />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-md-12 text-right">
//                                 <div className="m-page__button top-space">
//                                     <button type='button' onClick={this._doNavToPMPList} className='btn muted-button  deca-btn-orange'>Back</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//                 <Footer />
//             </div>
//         )
//     }
// }

// export default PMPScheduleCancel;



const StoresList = [
    {
        Label: "Connect Store - ITPB",
        Value: 1
    },
    {
        Label: "Connect Store- Indiranagar",
        Value: 2
    },
    {
        Label: "Sarjapur",
        Value: 3
    },
    {
        Label: "Anubhava (New Airport Road)",
        Value: 4
    },
    {
        Label: "EVA Mall - Brigade",
        Value: 5
    },
    {
        Label: "R-city(Mumbai)",
        Value: 6
    },
    {
        Label: "Amanora Mall",
        Value: 7
    },
    {
        Label: "OMR Padur(Chennai)",
        Value: 8
    },
    {
        Label: "Teynampet / Ramee Mall / Anna Salai",
        Value: 9
    },
    {
        Label: "Kukatpally (Manjeera Mall)",
        Value: 10
    },
    {
        Label: "Vishakapatnam (Murli Nagar)",
        Value: 11
    },
],
TableData = [
    {
        key: '1',
        MainCategory: "ELECTRICAL",
        SubCategory: "TRANSFORMER",
        VendorName: "Vendor 1",
        PMStartDate: "05-08-2021",
        PMEndDate: "05-12-2021"
    },
    {
        key: '2',
        MainCategory: "ELECTRICAL",
        SubCategory: "SWITCH BORAD",
        VendorName: "Vendor 2",
        PMStartDate: "05-08-2021",
        PMEndDate: "05-12-2021"
    },
    {
        key: '3',
        MainCategory: "ELECTRICAL",
        SubCategory: "Light System",
        VendorName: "Vendor 3",
        PMStartDate: "05-08-2021",
        PMEndDate: "05-12-2021"
    }

],
TableColumns = [
    {
        title: "Main Category",
        dataIndex: "MainCategory",
        key: "MainCategory"
    },
    {
        title: "Sub Category",
        dataIndex: "SubCategory",
        key: "SubCategory"
    },
    {
        title: "Vendor Name",
        dataIndex: "VendorName",
        key: "VendorName"
    },
    {
        title: "PM Start Date",
        dataIndex: "PMStartDate",
        key: "PMStartDate"
    },
    {
        title: "PM End Date",
        dataIndex: "PMEndDate",
        key: "PMEndDate"
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => (
            <Space size="middle">
                <div className="table-icons">
                    <span className="table-action cancel">Cancel</span>
                </div>
            </Space>
        ),
    }
]
function PMPScheduleCancel() {
    const title ="Preventive Maintenance Planner ";
    const navigate = useNavigate();
    const _doNavToPMPList = () => {
        navigate("/PMPList");
    };
    const _doSelectVender = () => {
        
    }
    return (
        <div className="wrapper">
            <Header title={title} />
            <Menu1 />
            <div className='content-wrapper'>
                <section className='content top-space'>
                    <div className="m-panel">
                        <div className="m-panel__body p10">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>Store*</label>
                                        <Select className="form-control"
                                            showSearch
                                            onChange={_doSelectVender}
                                            placeholder="-- Please Select --"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        > {
                                                StoresList.map((item =>
                                                    <Option value={item.Value}>{item.Label}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>PM start date</label>
                                        <DatePicker className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor='exampleInput'>PM end date</label>
                                        <DatePicker className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-3 btn-no-lbl">
                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'>
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="m-panel">
                        <div className="m-panel__body p10">

                            <div className="m-table__main">
                                <div className="m-table__responsive medium-width">
                                    <Table columns={TableColumns} dataSource={TableData} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <div className="m-page__button top-space">
                                <button type='button' onClick={_doNavToPMPList} className='btn muted-button  deca-btn-orange'>Back</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default PMPScheduleCancel
